import React from 'react';
import { ClipboardList } from 'lucide-react';
import ToolUnitPicker from '@/components/ToolUnitPicker';

export default function RubricGeneratorIndex() {
  return (
    <ToolUnitPicker
      title="Rubric Generator"
      subtitle="Create or browse AI-generated rubrics tailored to each unit's standards and essay prompts."
      icon={ClipboardList}
      accent="bg-yellow-600"
      buildTargetPath={(unit) => `/rubric-generator/${unit.id}`}
      ctaLabel="Open Rubric Tools"
    />
  );
}
